import { Col } from "antd";
import styled from "styled-components";
import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { CloseOutlined, MenuOutlined } from "@ant-design/icons";

import Layer3 from "src/assets/images/scense 1/Layer3.png";
import Senpark from "src/assets/images/scense 1/Senpark.png";
import { paramProduct } from "src/pages/Products";
import { paramCareer } from "src/pages/Careeres";
import { paramTeam } from "src/pages/Team";
import useBreakpoint from "antd/es/grid/hooks/useBreakpoint";
import metaverseBtn from "src/assets/images/NewScene/button_metaverse.png";

const Header = styled.section`
  padding: 3px 0;
  ul {
    margin: 0;
    padding: 0;
  }
  a {
    text-decoration: none;
    color: white;
  }
  li {
    list-style: none;
  }

  #menu li {
    height: 0;
    opacity: 0;
    transition: all 0.3s ease-out;
  }
  #toggle-menu:checked ~ #menu li {
    height: 40px;
    opacity: 1;
  }
  #menu a {
    font-size: 18px;
    display: block;
  }
  @media screen and (max-width: 600px) {
    padding-top: 5px;
    padding-bottom: 0;
  }
  .active {
    background-color: #e18136;
  }
`;

const Row = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  .logo {
    @media screen and (min-width: 1200px) {
      text-align: center;
    }
  }
  .screenPC {
    @media screen and (max-width: 768px) {
      display: none;
    }
  }
  .screenSp {
    text-align: right;
    cursor: pointer;
    color: white;
    @media screen and (min-width: 1024px) {
      display: none;
    }
  }
`;

const ImgTitle = styled.img`
  margin-top: 2px;
  height: 20px;
`;

const Button = styled.img`
  margin-top: 4px;
  height: 35px;
`;

const ImgSenPark = styled.img`
  height: 43px;
`;

const TextNav = styled.a`
  color: white;
  padding: 12px 20px 15px;
`;

const HeaderSection: React.FC = () => {
  const [isMenuSpOpen, setMenuSpOpen] = useState(true);
  const param = useLocation();
  const { lg } = useBreakpoint();

  return (
    <Header style={{ backgroundColor: "#e2432d" }}>
      <div className="container">
        <input type="checkbox" id="toggle-menu" hidden />
        <Row>
          <Col sm={13} lg={8} className="logo">
            <Link to={"/"}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <ImgSenPark src={Senpark} alt="" />
                <ImgTitle src={Layer3} alt="" />
              </div>
            </Link>
          </Col>
          {lg ? (
            <Col sm={11} className="screenPC">
              {/*<Link to={paramProduct}>*/}
              {/*  <TextNav*/}
              {/*    className={`${param.pathname === paramProduct && "active"}`}*/}
              {/*  >*/}
              {/*    Products*/}
              {/*  </TextNav>*/}
              {/*</Link>*/}
              <Link to={paramTeam}>
                <TextNav
                  className={`${param.pathname === paramTeam && "active"}`}
                >
                  Team
                </TextNav>
              </Link>
              {/*<TextNav>Team</TextNav>*/}
              {/*<TextNav>Blog</TextNav>*/}
              <Link to={paramCareer}>
                <TextNav
                  className={`${param.pathname === paramCareer && "active"}`}
                >
                  Careers
                </TextNav>
              </Link>
              <a href="https://www.facebook.com/TeamSenspark" target="_blank">
                <TextNav>Facebook</TextNav>
              </a>
              <a href="https://web3.senspark.com/" target="_blank">
                <Button src={metaverseBtn} />
              </a>
            </Col>
          ) : (
            <Col sm={5} className="screenSp">
              {isMenuSpOpen ? (
                <label
                  htmlFor="toggle-menu"
                  onClick={() => setMenuSpOpen(!isMenuSpOpen)}
                >
                  <MenuOutlined />
                </label>
              ) : (
                <label
                  htmlFor="toggle-menu"
                  onClick={() => setMenuSpOpen(!isMenuSpOpen)}
                >
                  <CloseOutlined />
                </label>
              )}
            </Col>
          )}
        </Row>
        <ul id="menu" style={{ display: isMenuSpOpen ? "none" : "block" }}>
          {/*<li>*/}
          {/*  <Link to={paramProduct}>Products</Link>*/}
          {/*</li>*/}
          <li>
            <Link to={paramTeam}>Team</Link>
          </li>
          {/*<li><a href="#">Team</a></li>*/}
          {/*<li><a href="#">Blog</a></li>*/}
          <li>
            <Link to={paramCareer}>Careers</Link>
          </li>
          <li>
            <a href="https://www.facebook.com/TeamSenspark" target="_blank">
              Facebook
            </a>
          </li>
        </ul>
      </div>
    </Header>
  );
};

export default HeaderSection;
